import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Neutral KPI tile: small label, large value; `color` survives as the status dot.
const MetricStat = ({
  icon,
  iconSrc,
  label,
  value,
  color = "#2563eb",
  subValue,
  subValueColor,
  boxed = false,
  horizontal = false,
  highlighted = false,
}) => {
  const icons = iconSrc ? (
    <img src={iconSrc} alt={label} className="pd-stat-icon-img" />
  ) : icon ? (
    <span className="pd-stat-icon">
      <FontAwesomeIcon icon={icon} />
    </span>
  ) : null;

  return (
    <div
      className={`pd-stat${horizontal ? " pd-stat-horizontal" : ""}${
        boxed ? " pd-stat-boxed" : ""
      }${highlighted ? " pd-stat-highlighted" : ""}`}
      style={{ "--pd-accent": color, "--pd-sub-accent": subValueColor || color }}
    >
      {icons}
      <span className="pd-stat-label">
        <i className="pd-stat-dot" aria-hidden="true" />
        {label}
      </span>
      <span className="pd-stat-figure">
        <span className="pd-stat-value">{value}</span>
        {subValue ? <span className="pd-stat-sub">{subValue}</span> : null}
      </span>
    </div>
  );
};

export default MetricStat;
